import { gorebilir, rol } from "./domain/auth.js";

// ---------- Menü tanımı ----------
// Kurum tarafı menüsü. Görünürlük rol yetkisiyle süzülür (§2).
const KURUM_NAV = [
  { group: "Günlük", items: [
    { id: "panel",    icon: "🏠", label: "Panel" },
    { id: "yoklama",  icon: "✋", label: "Yoklama" },
    { id: "rapor",    icon: "📝", label: "Günlük Rapor" },
    { id: "menu",     icon: "🍎", label: "Yemek Menüsü" },
    { id: "saglik",   icon: "🩺", label: "Sağlık" },
  ]},
  { group: "Kişiler", items: [
    { id: "ogrenciler", icon: "🎒", label: "Öğrenciler" },
    { id: "siniflar",   icon: "🧩", label: "Sınıflar" },
    { id: "personel",   icon: "🧑‍🏫", label: "Personel" },
    { id: "mesajlar",   icon: "💬", label: "Veli Mesajları" },
  ]},
  { group: "Yönetim", items: [
    { id: "odemeler",   icon: "🧾", label: "Ödemeler" },
    { id: "finans",     icon: "💰", label: "Finans" },
    { id: "raporlar",   icon: "📈", label: "Raporlar" },
    { id: "basvurular", icon: "📥", label: "Başvurular" },
    { id: "etkinlikler",icon: "🎈", label: "Etkinlik Takvimi" },
    { id: "ayarlar",    icon: "⚙️", label: "Şube Ayarları" },
    { id: "abonelik",   icon: "💳", label: "Abonelik" },
  ]},
];

// Sistem operatörü menüsü — kiracıların üstündeki katman.
const SISTEM_NAV = [
  { group: "Sistem", items: [
    { id: "sistem", icon: "🛰️", label: "Sistem Paneli" },
  ]},
];

// Veli portalı menüsü — kurum ekranlarıyla karışmaz.
const VELI_NAV = [
  { group: "Çocuğum", items: [
    { id: "bugun",      icon: "🌤️", label: "Bugün" },
    { id: "mesajlar",   icon: "💬", label: "Mesajlar" },
  ]},
  { group: "Kurum", items: [
    { id: "odemelerim", icon: "🧾", label: "Ödemelerim" },
    { id: "menu",       icon: "🍎", label: "Yemek Menüsü" },
    { id: "etkinlikler",icon: "🎈", label: "Etkinlik Takvimi" },
  ]},
];

/** Tüm menü tanımı — yetki süzgeci uygulanmamış hâli. */
export const TUM_NAV = [...SISTEM_NAV, ...KURUM_NAV, ...VELI_NAV];

/** Oturumdaki role göre görünen menü. Boş grup gösterilmez. */
export function nav() {
  // Sistem operatörüne KURUM_NAV verilmiyor. Eskiden veriliyordu
  // ("destek verebilmeli") ama bu, sistem panelinin kendi ilkesiyle
  // çelişiyordu: panelde çocuk adı göstermemeye özen gösterip kenar
  // çubuğundan Öğrenciler ve Sağlık ekranlarını açmak tutarsızdı.
  // Firestore kuralları da artık bu veriyi vermiyor.
  const kaynak =
    rol() === "sistem" ? SISTEM_NAV
    : rol() === "veli" ? VELI_NAV
    : KURUM_NAV;
  return kaynak
    .map(g => ({ ...g, items: g.items.filter(i => gorebilir(i.id)) }))
    .filter(g => g.items.length);
}

export const VIEW_TITLES = Object.fromEntries(
  TUM_NAV.flatMap(g => g.items.map(i => [i.id, i.label])),
);

/** Rolün açılışta göreceği ilk ekran. */
export function varsayilanGorunum() {
  const ilk = nav()[0]?.items[0]?.id;
  return ilk ?? "panel";
}
